import axios from 'axios';

const openstreetmap = axios.create({
  baseURL: 'https://nominatim.openstreetmap.org',
});

export default openstreetmap;
